import { AulaDispatch } from '@core/types/state';
import { INBOX_CHANGE_CONVERSATION_NAME } from '../actions';

const changeConversationName =
  (newValue: string) => (dispatch: AulaDispatch) => {
    dispatch({
      type: INBOX_CHANGE_CONVERSATION_NAME,
      payload: newValue,
    });
  };

export default changeConversationName;
